import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { DataService } from 'app/services/data.service';
import { currency } from 'app/constants/currency.constants';

@Component({
  selector: 'app-calculator-change-dialog',
  templateUrl: './calculator-change-dialog.component.html',
  styleUrls: ['./calculator-change-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService],
})
export class CalculatorChangeDialogComponent implements OnInit {
  data: any = {};
  isValid: boolean = false;
  confirmationText: string = '';
  amount = null;
  change: any;
  validate: any = {};
  focus: any = { collectedAmount: false };
  timeoutId: any;
  usd: string = currency.USD;

  constructor(private dialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private dataService: DataService) {}

  ngOnInit() {
    this.data = this.dialogConfig.data;
  }

  handleChange(value: string) {
    this.focus.collectedAmount = true;
    this.amount = value;
    this.change = '';
    // if(this.timeoutId) clearTimeout(this.timeoutId);
    // this.timeoutId = setTimeout(()=> {
    //   this.validation();
    // },1000);
  }

  handleFocus() {
    this.focus.collectedAmount = true;
    this.validate.amount = '';
    if (isNaN(this.amount)) {
      this.amount = 0;
    }
  }

  validation() {
    this.focus.collectedAmount = false;
    this.validate.amount = '';
    this.amount = this.amount.replace(/[^\d.-]+/g, '');
    if (this.amount < this.data.payment.collectedAmount) {
      this.validate.amount = '*Cash received cannot be less than amount';
      this.change = '';
      return;
    }

    this.change = this.amount - this.data.payment.collectedAmount;
  }

  closeDialog(isSuccess: boolean, btn = '') {
    this.data.btn = btn;
    this.dataService.sendData(this.dataService.typePassData('modal-closed', {}));
    this.dynamicDialogRef.close({ isSuccess, data: this.data });
  }
}
